import React from "react";
import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import AniLink from "gatsby-plugin-transition-link/AniLink";

import { SocialLinks as Social } from "../social";
import StickyNavigation from "./StickyNavigation";
import Logo from "./Logo";


import { NavBarProps } from "./types";

const NavBar: React.FC<NavBarProps> = ({ navigation, socialLinks, title, logo }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const enableNav = navigation?.length > 1

  return (
    <StickyNavigation mobileMenuOpen={mobileMenuOpen}>
      <div className="bg-brown-600/90">
        <nav
          className="max-w-[1400px] mx-auto px-6 py-4 md:py-6 md:px-8 flex items-center justify-between"
          aria-label="Global"
        >
          <div className="flex md:min-w-0 md:flex-1" aria-label="Global">
            <Logo title={title} logo={logo} />
            <div className="hidden lg:flex -mt-[2px] ml-8">
              <Social links={socialLinks} location="navbar" />
            </div>
          </div>
          {enableNav && <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white hover:text-brown-200 transition-all"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Abrir menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>}
          {enableNav && <div className="hidden lg:flex md:min-w-0 md:gap-x-6">
            {navigation?.map((item) => (
              <AniLink
                paintDrip
                hex="#111"
                key={item.title}
                to={item.path}
                className="font-semibold text-lg text-white hover:underline transition-all font-cursive uppercase [&.active]:text-brown-200 [&.active]:underline"
                activeClassName="active"
              >
                {item.title}
              </AniLink>
            ))}
          </div>}
        </nav>
        {enableNav && <Dialog
          as="div"
          className="bg-brown-200"
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
        >
          <Dialog.Panel
            className="fixed inset-0 z-10 overflow-y-auto bg-brown px-6 lg:hidden max-h-screen"
          >
            <div className="flex h-9 items-center justify-between fixed right-6 top-3">
              <div className="flex" />
              <div className="flex">
                <button
                  type="button"
                  className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white hover:text-brown-200 transition-all"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <span className="sr-only">Fechar menu</span>
                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
            </div>
            <div className="flex justify-center flex-col min-h-screen">
              <div className="py-10 flex justify-between min-h-screen flex-col">
                <div className="flex">
                  <AniLink
                    paintDrip
                    hex="#111"
                    to="/"
                    className="mx-auto mt-5 mb-6"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <span className="sr-only">{title}</span>
                    <div
                      className="[&>svg]:fill-brown-200 [&>svg]:h-8 [&>svg]:md:h-8"
                      dangerouslySetInnerHTML={{ __html: logo }}
                    />
                  </AniLink>
                </div>
                <div className="space-y-2">
                  {navigation?.map((item) => (
                    <AniLink
                      paintDrip
                      hex="#111"
                      key={item.title}
                      to={item.path}
                      onClick={() => setMobileMenuOpen(false)}
                      className="mx-auto w-full text-center block py-2 px-3 font-semibold text-3xl text-white hover:underline transition-all font-cursive uppercase [&.active]:text-brown-200 [&.active]:underline"
                      activeClassName="active"
                    >
                      {item.title}
                    </AniLink>
                  ))}
                </div>
                <div>
                  <Social links={socialLinks} location="navbar" />
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>}
      </div>
    </StickyNavigation>
  );
};

export default NavBar;
